import { CourseDto } from './course.dto';
import { Course } from '@lyceo/homi/shared/util-models';

export function mapCourse(courseDto: CourseDto): Course {
  return {
    id: courseDto.id,
    name: courseDto.name,
    shortName: courseDto.shortName,
  };
}
